import { AxiosResponseHeaders } from 'axios';
import { BopCodesResponseDTO, BopCode } from '../entities';

const bopCodesResponseDTOToBopCodesAdapter = (data: BopCodesResponseDTO, headers?: AxiosResponseHeaders): BopCode[] => {
  if (!data.body) {
    throw new Error('Error');
  }
  console.log(data.body);
  return data.body.bopCodes.map(bc => new BopCode(bc.serialNumber, bc.description, bc.shortDescription));
};

export { bopCodesResponseDTOToBopCodesAdapter };
